export function applyWhiteLabelHeadTags(whiteLabelImages) {
	if (!whiteLabelImages) return;

	if (whiteLabelImages.favicon) {
		try {
			let link =
				document.querySelector("link[rel*='icon']") ||
				document.createElement('link');
			link.type = 'image/x-icon';
			link.rel = 'shortcut icon';
			link.href = whiteLabelImages.favicon + "?time=" + Date.now();
			document.getElementsByTagName('head')[0].appendChild(link);
			localStorage.setItem('wl_favicon', whiteLabelImages.favicon);
		} catch (e) {}
	}

	if (whiteLabelImages.appleTouchIcon) {
		try {
			let appleTouchLink =
				document.querySelector("link[rel='apple-touch-icon']") ||
				document.createElement('link');
			appleTouchLink.rel = 'apple-touch-icon';
			appleTouchLink.sizes = '180x180';
			appleTouchLink.href = whiteLabelImages.appleTouchIcon + "?time=" + Date.now();
			document.getElementsByTagName('head')[0].appendChild(appleTouchLink);
			// Cache the bare URL so it can be re-applied synchronously on the next
			// visit (see inline script in public/index.html), before the app has
			// fetched fresh integration data. Mobile Safari reads this tag when the
			// "Add to Home Screen" sheet opens, which can happen before that fetch resolves.
			localStorage.setItem('wl_appleTouchIcon', whiteLabelImages.appleTouchIcon);
		} catch (e) {}
	}

	if (whiteLabelImages.openGraphImage) {
		try {
			let ogImageMeta =
				document.querySelector("meta[property='og:image']") ||
				document.createElement('meta');
			ogImageMeta.setAttribute('property', 'og:image');
			ogImageMeta.setAttribute('content', whiteLabelImages.openGraphImage + "?time=" + Date.now());
			document.getElementsByTagName('head')[0].appendChild(ogImageMeta);
			localStorage.setItem('wl_openGraphImage', whiteLabelImages.openGraphImage);
		} catch (e) {}
	}

	if (whiteLabelImages.twitterCardImage) {
		try {
			let twitterCardMeta =
				document.querySelector("meta[name='twitter:card']") ||
				document.createElement('meta');
			twitterCardMeta.setAttribute('name', 'twitter:card');
			twitterCardMeta.setAttribute('content', 'summary_large_image');
			document.getElementsByTagName('head')[0].appendChild(twitterCardMeta);

			let twitterImageMeta =
				document.querySelector("meta[name='twitter:image']") ||
				document.createElement('meta');
			twitterImageMeta.setAttribute('name', 'twitter:image');
			twitterImageMeta.setAttribute('content', whiteLabelImages.twitterCardImage + "?time=" + Date.now());
			document.getElementsByTagName('head')[0].appendChild(twitterImageMeta);
			localStorage.setItem('wl_twitterCardImage', whiteLabelImages.twitterCardImage);
		} catch (e) {}
	}

	if (whiteLabelImages.structuredDataLogo) {
		try {
			let ldJsonScript =
				document.querySelector("script[data-whitelabel-schema='true']") ||
				document.createElement('script');
			ldJsonScript.type = 'application/ld+json';
			ldJsonScript.setAttribute('data-whitelabel-schema', 'true');
			ldJsonScript.textContent = JSON.stringify({
				"@context": "https://schema.org",
				"@type": "Organization",
				"url": window.location.origin,
				"logo": whiteLabelImages.structuredDataLogo + "?time=" + Date.now(),
			});
			document.getElementsByTagName('head')[0].appendChild(ldJsonScript);
			localStorage.setItem('wl_structuredDataLogo', whiteLabelImages.structuredDataLogo);
		} catch (e) {}
	}
}
